const About = () => {
  return (
    <div className="Pages">
      <h1>About</h1>
      <div>
        <img className="floatImage" src="./Oberman-small.jpg" alt="headshot" /></div>
      <div>
        <p>Hi, I'm Brian Oberman.</p>
        <p>I grew up in large family and both my parents worked hard to provide for us. I started working at age 12 and had to pay for my sports equipment. And, I recall
          saving money to buy a 10-speed bike.  I also recall going in on a Certificate of Deposit(CD) with my dad at age 14.  The CD paid 14%!
          The ability to make money from money (even though it was a small amount) caused me to want to learn more about money, and how to get more of it.
        </p>
        <p>I spent most of my twenties reading books about money exclusively.  I learned the power of automation.  Taking $50 per month automatically from my checking into mutual funds.
          I started to grow my investment accounts over time. My love for learning about money and investing continued.
        </p>
        <p>I got a job in the financial services industry and have worked there over 30 years.  I also worked on a special effort to help "middle-class" folks.
          This included conducting research.  What I discovered and heard was shocking. And, disheartening.  People needed financial help.  However, they either 
          could not afford it (from the "experts").  Or they weren't sure where to start.  Or, they were turned away from the "experts" because they did not have
          enough assets or income to garner any attention from the expert.  Or, they believed they could do it themselves. 
        </p>
        <p>To that end, after gaining numerous certifications, lots of education, and personal experience that has made me a millionaire, I want to
          help others.  I can help you no matter which of the above categories you fit into. We all need a financial coach.  A coach that will meet you where you are
          and not have a conflict of interest.  I don't sell any financial products. I won't take a percentage of your assets.  And, I won't waste your time.
          I will help you achieve your financial victory!
        </p>
        </div>
    </div>
  );
};

export default About;
